export default __webpack_public_path__ + "img/label.puroak.05.asset.30111b3f.png";